import React from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import CustomToolbar from '../common/datagrid/CustomToolbar';
import CustomLoadingOverlay from '../common/datagrid/CustomLoadingOverlay';

const TechList = ({ reqStatus, columns, rows, loading, handleRowClick }) => {
  const [pageSize, setPageSize] = React.useState(20);
  const [height, setHeight] = React.useState("calc(100vh - 240px)")

  React.useEffect(() => {
    if (reqStatus) {
      setHeight('calc(100vh - 280px)')
    }


  }, [reqStatus])

  return (
    <div style={{ display: 'flex', height: height }}>
      <div style={{ flexGrow: 1 }}>
        <DataGridPro
          rows={rows ? rows : []}
          columns={columns}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{
            toolbar: { fileName: '지원요청리스트' },
          }}
          loading={loading}
          onRowClick={handleRowClick}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          pagination
        />
      </div>
    </div>
  );
};

export default TechList;
